import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBusinessContractHandshakeSign = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "business-contract-handshake-sign" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.25.75H3.75a3,3,0,0,0-3,3v18a1.5,1.5,0,0,0,1.5,1.5H3.685"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.75,
			y1: 4.5,
			x2: 10.5,
			y2: 4.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.75,
			y1: 7.5,
			x2: 10.5,
			y2: 7.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.75,
			y1: 10.5,
			x2: 7.109,
			y2: 10.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15,9.75V3A2.257,2.257,0,0,1,17.25.75h0A2.256,2.256,0,0,1,19.5,3V4.5H15"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 21.75,
			y1: 19.61,
			x2: 16.963,
			y2: 20.568
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.438,15.138l-2.26.954a1.42,1.42,0,0,1-1.122-.015,1.483,1.483,0,0,1-.781-.831,1.525,1.525,0,0,1,.706-1.9l2.259-1.128a1.972,1.972,0,0,1,1.594-.094l4.639,1.828"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.2,20.606h1.6l3.049,2.326a.83.83,0,0,0,1.15.09l4.26-3.518a.842.842,0,0,0,.129-1.164l-2.347-2.609"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M13.736,13.506l-.247-.2a1.79,1.79,0,0,0-1.725-.22L8.194,14.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.75,21.356h.3a1.141,1.141,0,0,0,1.2-1.071V14.927a1.141,1.141,0,0,0-1.2-1.071h-.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.25,21.356h-.3a1.141,1.141,0,0,1-1.2-1.071V14.927a1.141,1.141,0,0,1,1.2-1.071h.3"
		})
	]
});
export default SvgBusinessContractHandshakeSign;
